import { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/future/image";

import { Container } from "react-bootstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

import arrow from "../../assets/images/arrow-up.png";

const Hero = ({ heroData, socials }) => {
  const { locale } = useRouter();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const renderHeroItems = heroData?.map((item) => (
    <SwiperSlide key={item?.slug}>
      <div className="cap">
        <Container>
          <div className="h-item">
            <h3>{item?.sectionTitle?.[locale]}</h3>
            <p>{item?.description?.[locale]}</p>
          </div>
        </Container>
      </div>
      <Image
        src={`${process.env.NEXT_PUBLIC_MAIN_URL}/${item?.image}`}
        width={1920}
        height={900}
        alt=""
        priority
      />
    </SwiperSlide>
  ));

  const renderThumbnails = heroData?.map((thumb, index) => {
    return (
      <SwiperSlide key={"thumb" + thumb?.slug}>
        <div className="thumb-item">
          <h4>{thumb?.thumbnail?.[locale]}</h4>
        </div>
      </SwiperSlide>
    );
  });

  const scrollFunction = () => {
    let e = document.getElementById("aboutUs");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  };

  return (
    <>
      <div className="slider">
        <div className="hero-slider">
          <Swiper
            spaceBetween={10}
            pagination={false}
            thumbs={{ swiper: thumbsSwiper, Autoplay, EffectFade }}
            modules={[Pagination, Thumbs]}
            effect={"fade"}
            className="mySwiper2"
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
          >
            {renderHeroItems}
          </Swiper>
        </div>
        <div className="thumbs-slider">
          <Container>
            <Swiper
              onSwiper={setThumbsSwiper}
              spaceBetween={10}
              slidesPerView={5}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[Thumbs]}
              className="mySwiper"
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                991: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
            >
              {renderThumbnails}
            </Swiper>
          </Container>
        </div>
        <div className="scroll-area">
          <button onClick={scrollFunction}>
            <span>scroll</span>
            <div>
              <Image
                src={arrow.src}
                width={10}
                height={20}
                alt=""
                loading="lazy"
              />
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default Hero;
